import { render } from "./FridgeDetailsSelectDateBar.vue?vue&type=template&id=1163bbc4&scoped=true&ts=true"
import script from "./FridgeDetailsSelectDateBar.vue?vue&type=script&lang=ts"
export * from "./FridgeDetailsSelectDateBar.vue?vue&type=script&lang=ts"

import "./FridgeDetailsSelectDateBar.vue?vue&type=style&index=0&id=1163bbc4&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1163bbc4"]])

export default __exports__